import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Routes } from "./routes/Routes";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import "./i18n/i18n";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./auth/useAuth";
const twentyFourHoursInMs = 1000 * 60 * 60 * 24;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: twentyFourHoursInMs,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    {/*
      Toasts sit above MUI's modal layer (z-index 1300) so an upload error
      raised from inside a dialog is actually readable. The top offset clears
      the dialog's own title row — at the default `top: 0` the toast landed
      directly on "Modifier la marque", hiding the very context the error
      referred to.
    */}
    <Toaster
      position="top-right"
      reverseOrder={false}
      containerStyle={{ top: 24, right: 24, zIndex: 2000 }}
      toastOptions={{
        duration: 5000,
        style: { maxWidth: 420, wordBreak: "break-word" },
        error: { duration: 7000 },
      }}
    />
    <QueryClientProvider client={queryClient}>
      {/* AuthProvider sits inside QueryClientProvider (it fetches
          /me/permissions) and outside BrowserRouter, so route guards can read
          permissions on the very first render. */}
      <AuthProvider>
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
